import { render } from "./Become_agency.vue?vue&type=template&id=02bf53df"
import script from "./Become_agency.vue?vue&type=script&lang=js"
export * from "./Become_agency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__